rs.module("controls/components/userbar",

    [
        "controls/diagnostics/debugpane",
        "controls/help/helphost",
        "controls/diagnostics/scriptlog"
    ],

    function (debugPane, help, scriptLog) {

        var _jsSelectors;
        var _cssClasses;
        var _tooltipText;

        const _hoverDelay = 400;

        // Initialize the menu
        function initialize(jsSelectors, cssClasses, tooltipText) {

            _jsSelectors = jsSelectors;
            _cssClasses = cssClasses;
            _tooltipText = tooltipText;

            var userLinks = $.js(_jsSelectors.userDropDownMenu).js(_jsSelectors.userMenuLink, { multiple: true });
            var helpLinks = $.js(_jsSelectors.helpMenu).js(_jsSelectors.helpMenuLink, { multiple: true });

            // Listen for show\hide clicks
            $.js(_jsSelectors.helpToggle, { multiple: true }).on("click", _onToggleHelp);
            $.js(_jsSelectors.helpMenuToggle).on("click", _onToggleHelpMenu);

            // Listen for show\hide of debug toggle only if it exists
            var debugToggle = $.js(_jsSelectors.debugToggle, { required: false });
            if (debugToggle.length > 0) {

                // Handle debug toggle clicking
                debugToggle.on("click",
                    function () {
                        debugPane.visible = !debugPane.visible;

                        _updateButtonToggle(_jsSelectors.debugToggle, debugPane.visible);
                    });

                // toggle the debug button state based on whether the debug pane is open
                _updateButtonToggle(_jsSelectors.debugToggle, debugPane.visible);
            }

            // Listen for javascript errors to display an indicator
            scriptLog.onJsError(function () {
                // Show the indicator, select with required:false because of Production mode
                $.js(jsSelectors.debugAlert, { required: false }).removeClass(cssClasses.hidden);
            });

            // Show/hide user drop down when username has focus
            $.js(_jsSelectors.username).focus(function () { toggleDropDown($.js(_jsSelectors.userDropDownMenu), true); });
            $.js(_jsSelectors.username).blur(function () { toggleDropDown($.js(_jsSelectors.userDropDownMenu), false); });
            $.js(_jsSelectors.helpMenuToggle).focus(function () { toggleDropDown($.js(_jsSelectors.helpMenu), true); });
            $.js(_jsSelectors.helpMenuToggle).blur(function () { toggleDropDown($.js(_jsSelectors.helpMenu), false); });

            // Due to the order event handlers get executed, the blur event on the username fires before the click event of user menu links.
            // Because of this, the blur handler ends up hiding the drop down before the click event fires, which results in clicking a menu link doing nothing
            // However, since the mousedown event fires just before the blur event, we are able to suppress the default behavior of hiding the drop down on blur.
            // Then, when the click event fires, we will hide the drop down at that point
            userLinks.mousedown(event, function () { event.preventDefault(); });
            userLinks.click(event, function () { $.js(_jsSelectors.username).blur(); });
            helpLinks.mousedown(function (event) { event.preventDefault(); });
            helpLinks.click(function () { event.stopPropagation(); $.js(_jsSelectors.helpMenuToggle).blur(); });

            // show hide themes menu on hover with intent
            $.js(_jsSelectors.themeLink).hoverIntent({
                handlerOver: function (event) { toggleDropDown($.js(_jsSelectors.themesMenu), true); },
                handlerOut: function (event) { toggleDropDown($.js(_jsSelectors.themesMenu), false); },
                hoverOutDelay: _hoverDelay
            });

            $.js(_jsSelectors.themeLink).mousedown(event, function () {

                // if the user clicks the Themes link clear the enter timer and show themes menu immediately
                $.js(_jsSelectors.themesMenu).toggleClass(_cssClasses.visible, true);

                // prevent clicking on Themes link in the main menu from closing the drop down
                event.preventDefault();
            });

            // because of the previous line, we need to force close the menu once a theme is clicked in the themes sub menu
            $.js(_jsSelectors.themesMenu).click(event, function () { $.js(_jsSelectors.username).blur(); });
        }

        // Displays a toggle button as being pressed or not
        function _updateButtonToggle(selector, toggled) {
            if ($.js(selector).is("a")) {
                $.js(selector).toggleClass(_cssClasses.toggled, toggled)
            }
            else {
                $.js(selector).find("a").each(function () {
                    $(this).toggleClass(_cssClasses.toggled, toggled);
                });
            }
        }

        // Prevent bubbling of the click
        function _onToggleHelpMenu(e) {
            e.stopPropagation();
            e.preventDefault();
        }

        // Toggle the help UI
        function _onToggleHelp(e) {
            e.stopPropagation();

            help.visible = !help.visible;

            // update the toggle button
            _updateButtonToggle(_jsSelectors.helpButton, help.visible);

            // update tooltip and menu text
            $.js(_jsSelectors.helpButton).attr("title", help.visible ? _tooltipText.hideFieldHints : _tooltipText.showFieldHints);
            $.js(_jsSelectors.helpMenu).js(_jsSelectors.helpToggle).text(help.visible ? _tooltipText.hideFieldHints : _tooltipText.showFieldHints);
        }

        //
        // Toggle the visibilty of a drop down
        //
        function toggleDropDown(dropdown, visible) {
            dropdown.toggleClass(_cssClasses.visible, visible);
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);